import { addons } from '@storybook/addons'
import labsixTheme from './labsixTheme'

addons.setConfig({
  theme: labsixTheme,
})
